import React from 'react'
import { getValueElement, printKey } from '../TableCompare/utils'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

const TableDetail = ({ detail }) => {
  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          { Object.keys(detail).map((field, index) => (
            <TableRow key={`table-columd-body-${field}-${index}`}>
              <TableCell align='right' width={80}>
                <Typography component={'p'} color='primary' variant='inherit' className='text-sm py-1 font-bold'>{printKey(field)}</Typography>
              </TableCell>
              <TableCell>
                <Typography component={'p'} variant='inherit' className='text-sm py-1 overflow-hidden'>{getValueElement(detail[field], field)}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TableDetail